<dds-dropdown theme="dark"
              kind="silent"
              size="lg"
              [label]="category.title"
              width="full"
              [isInverse]="true"
              [isResponsive]="false"
              [stickerWidth]="getStickerWidth()"
              stickerPosition="bottom"
              [stickerIndent]="-8"
              stickerCustomClass="category-dropdown-sticker_{{category.theme}}"
              class="category-dropdown category-dropdown_{{category.theme}}"
              [class.selected]="isSelected"
              (itemSelected)="changeItem($event)"
              #dropdown>

  @for (item of category.list; track item) {
    <dds-dropdown-item [value]="item">{{item.title}}</dds-dropdown-item>
  }

</dds-dropdown>
